import styled from "styled-components/macro";
import * as S from "components/common/Advice/Advice.style"  

export const Container = styled.section(({ theme }) => ({
    ...S.FactoryContainer({theme}),
    "@media (min-width: 1200px) and (max-width: 1400px)": {
        padding: "50px 156px 64px 220px",
    },
    
    [theme.breakpoint.xl()]: {
        padding : "50px 156px 64px 320px"
    },
}));

export const Title = S.Title;
export const Paragraph = S.Paragraph;